import { proxyCustomElement, HTMLElement } from '@stencil/core/internal/client';

/**
 * Convert seconds into timestring such as `01:30`
 * If the duration is more than an hour, an hour indicator is prefixed
 *
 * @param seconds seconds to convert
 * @returns Period in timeformat
 */
function secondsToTime(seconds) {
  if (!Number.isInteger(seconds)) {
    throw TypeError(`Seconds needs to be integer, got ${seconds}`);
  }
  const h = Math.floor(seconds / 3600) > 0 &&
    Math.floor(seconds / 3600)
      .toString()
      .padStart(2, '0');
  const m = Math.floor((seconds % 3600) / 60)
    .toString()
    .padStart(2, '0');
  const s = Math.floor(seconds % 60)
    .toString()
    .padStart(2, '0');
  return `${h ? `${h}:` : ''}${m}:${s}`;
}

const FormatDuration = /*@__PURE__*/ proxyCustomElement(class extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.value = 0;
  }
  render() {
    if (isNaN(this.value)) {
      return '';
    }
    return secondsToTime(this.value);
  }
}, [1, "tt-format-duration", {
    "value": [2]
  }]);
function defineCustomElement() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["tt-format-duration"];
  components.forEach(tagName => { switch (tagName) {
    case "tt-format-duration":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, FormatDuration);
      }
      break;
  } });
}

export { FormatDuration as F, defineCustomElement as d };
